<template>
  <div>
    <Head title="Kthimet i mjeteve" />
    <h1 class="mb-8 text-3xl font-bold">Kthimet e mjeteve</h1>


    <div  class="flex flex-wrap lg:flex-nowrap w-full lg:w-1/2 mb-4">

      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Biznesi shitës:</label>
        <select v-model="form.business_id" class="form-select mt-1 w-full">
          <option :value="null">Të gjitha</option>
          <option v-for="business in businesses" :value="business.id">{{ business.name }}</option>
        </select>


        <label class="block text-gray-700">Pika marrëse:</label>
        <select v-model="form.location_id" class="form-select mt-1 w-full">
          <option :value="null">Të gjitha</option>
          <option v-for="location in selectedLocations" :value="location.id">{{ location.name }}</option>
        </select>

        <label class="block mt-4 text-gray-700">Të barazuara:</label>
        <select v-model="form.barazuar" class="form-select mt-1 w-full">
          <option :value="null">Të gjitha</option>
          <option value="true">Po</option>
          <option value="false">Jo</option>
        </select>
      </search-filter>
    </div>

    <div class="flex flex-wrap  mb-6 lg:mb-6">

      <div class="pr-5 w-full lg:w-1/5">
        <label class="form-label text-gray-700">Statusi:</label>
        <Multiselect
          v-model="form.status_ids"
          :options="filterStatuses.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />

      </div>

      <div class="pr-5 w-full lg:w-1/5">
        <label class="form-label">Shteti:</label>
        <Multiselect
          v-model="form.country_ids"
          :options="filterCountries.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />
      </div>

      <div class="pr-5 w-full lg:w-1/5">
        <label class="form-label">Qyteti:</label>
        <Multiselect
          v-model="form.city_ids"
          :options="filterCities.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />
      </div>

      <div class="pr-5 w-full lg:w-1/5">
        <label class="form-label">Shoferi shpërndarës:</label>
        <Multiselect
          v-model="form.delivery_driver_ids"
          :options="filterDeliveryDrivers.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />
      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Nga data e regjistrimit:</label>
        <input v-model="form.start_date" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Deri në datën(duke mos e përfshirë):</label>
        <input v-model="form.end_date" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>


      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Nga data e ndryshimit të statusit:</label>
        <input v-model="form.start_date_status_updated" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Deri në datën(duke mos e përfshirë):</label>
        <input v-model="form.end_date_status_updated" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Nga data e likuidimit:</label>
        <input v-model="form.start_date_barazuar" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Deri në datën(duke mos e përfshirë):</label>
        <input v-model="form.end_date_barazuar" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>

    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6"></th>
          <th class="pb-4 pt-6 px-6">ID</th>
          <th class="pb-4 pt-6 px-6" >Statusi</th>
          <th class="pb-4 pt-6 px-6">Dërgesa</th>
          <th class="pb-4 pt-6 px-6">Kthimi i dërgesës</th>
          <th class="pb-4 pt-6 px-6">Biznesi shitës</th>
          <th class="pb-4 pt-6 px-6">Pika marrëse</th>
          <th class="pb-4 pt-6 px-6">Shuma e mjeteve</th>
          <th class="pb-4 pt-6 px-6">Posta</th>
          <th class="pb-4 pt-6 px-6">Emri i blerësit</th>
          <th class="pb-4 pt-6 px-6" >Telefoni i blerësit</th>
          <th class="pb-4 pt-6 px-6" >Qyteti</th>

          <th class="pb-4 pt-6 px-6" >Krijuar më</th>
          <th class="pb-4 pt-6 px-2">Statusi edituar më</th>
          <th class="pb-4 pt-6 px-2">Likuiduar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="moneyReturn in moneyReturns.data" :key="moneyReturn.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="w-px border-t">
            <Link class="flex items-center  px-2 py-4" :href="`mjetet/${moneyReturn.id}`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              <icon v-if="moneyReturn.barazim_id" name="paid" class="flex-shrink-0 ml-2 w-5 h-5 fill-gray-400" />

            </Link>
          </td>
          <td class="border-t px-2">
              {{ moneyReturn.id }}
          </td>
          <td class="border-t px-2">
            <span class="mx-0.5 px-2 py-1 rounded-md text-white" v-bind:class="getStatusColor(moneyReturn.status_id)">{{ moneyReturn.status }}</span>
          </td>
          <td class="border-t px-2">
            <a class="flex items-center px-6 py-4 focus:text-indigo-500" target="_blank" :href="`dergesat/${moneyReturn.order_id}`">
              {{ moneyReturn.order_id }}
            </a>
          </td>
          <td  class="border-t px-2">
            <a  class="flex items-center px-6 py-4 focus:text-indigo-500" target="_blank" :href="`nderrimet/${moneyReturn.order_change_id}`">
              {{ moneyReturn.order_change_id}}
            </a>
          </td>
          <td  class="border-t px-2">
              {{ moneyReturn.business }}
          </td>
          <td class="border-t px-2">
              {{ moneyReturn.paid_by_seller ? moneyReturn.location : 'Mjetet te mirren nga posta' }}
          </td>
          <td class="border-t px-2">
              {{ moneyReturn.amount }}
          </td>
          <td class="border-t px-2">
              {{ moneyReturn.shipping_price }}
          </td>
          <td class="border-t px-2">
              {{ moneyReturn.client }}
          </td>
          <td class="border-t px-2">
              {{ moneyReturn.phone }}
          </td>
          <td class="border-t px-2">
              {{ moneyReturn.city }}
          </td>

          <td class="border-t px-2">
              {{ moneyReturn.hr_created_at }}
          </td>
          <td class="border-t px-2">
            {{ moneyReturn.updated_status_at }}
          </td>
          <td class="border-t px-2">
            {{ moneyReturn.barazuar_at }}
          </td>
          <td class="w-px border-t">
            <dropdown class="mt-1" placement="bottom-end">
              <template #default>
                <icon name="three-dots" class="block w-12 h-6 fill-gray-400"/>
              </template>
              <template #dropdown>
                <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('print.money-return.pdf',{moneyReturn: moneyReturn.id})" target="_blank">Printo PDF</a>
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('print.money-return.sticker.8x5',{moneyReturn: moneyReturn.id})" target="_blank">Printo Stiker 8x5cm</a>
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('print.money-return.sticker.10x7',{moneyReturn: moneyReturn.id})" target="_blank">Printo Stiker 10x7cm</a>
                </div>
              </template>
            </dropdown>
          </td>
        </tr>
        <tr v-if="moneyReturns.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">Nuk u gjet asnjë rekord.</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="flex flex-wrap">
      <select-input v-model="form.per_page"  class="p-0 mt-6 mr-5 w-1/4 lg:w-1/12"
      >
        <option v-if="moneyReturns.meta.total > 15" value="15">15 / {{moneyReturns.meta.total}}</option>
        <option v-if="moneyReturns.meta.total > 30"  value="30">30 / {{moneyReturns.meta.total}}</option>
        <option v-if="moneyReturns.meta.total > 50"  value="50">50 / {{moneyReturns.meta.total}}</option>
        <option v-if="moneyReturns.meta.total > 100"  value="100">100 / {{moneyReturns.meta.total}}</option>
        <option :value="moneyReturns.meta.total">{{moneyReturns.meta.total}} / {{moneyReturns.meta.total}}</option>

      </select-input>

      <pagination class="mt-6" :links="moneyReturns.meta.links"/>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import DangerFlashMessage from '@/Shared/DangerFlashMessage'
import axios from 'axios'
import Dropdown from '@/Shared/Dropdown'
import Multiselect from '@vueform/multiselect'
import SelectInput from '@/Shared/SelectInput'

export default {
  components: {
    DangerFlashMessage,
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    Dropdown,
    Multiselect,
    SelectInput
  },
  props: {
    moneyReturns: Object,
    filters: Object,
    locations: Object,
    businesses: Object,
    statuses: Object,
    countries: Object,
    cities: Object,
    deliveryDrivers: Object
  },
  data(){
    return {
      form: {
        search: this.filters.search,
        location_id: this.filters.location_id,
        business_id: this.filters.business_id,
        status_ids: this.filters.status_ids,
        country_ids: this.filters.country_ids,
        city_ids: this.filters.city_ids,
        delivery_driver_ids: this.filters.delivery_driver_ids,
        barazuar: this.filters.barazuar,
        start_date: this.filters.start_date,
        end_date: this.filters.end_date,
        start_date_status_updated: this.filters.start_date_status_updated,
        end_date_status_updated: this.filters.end_date_status_updated,
        start_date_barazuar: this.filters.start_date_barazuar,
        end_date_barazuar: this.filters.end_date_barazuar,

        per_page: this.moneyReturns.meta.total < 15 ? this.moneyReturns.meta.total : this.moneyReturns.meta.per_page,
      },
      filterStatuses: {
        options: this.statuses.map(function(status){
          return {value: status.id, label: status.name}
        }),
      },
      filterCountries: {
        options: this.countries.map(function(country){
          return {value: country.id, label: country.name}
        }),
      },
      filterCities: {
        options: this.cities.map(function(city){
          return {value: city.id, label: city.name}
        }),
      },
      filterDeliveryDrivers: {
        options: this.deliveryDrivers.map(function(deliveryDriver){
          return {value: deliveryDriver.id, label: deliveryDriver.name}
        }),
      },
      selectedLocations: this.locations,
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/admin/mjetet', pickBy(this.form), {preserveState: true})
      }, 150),
    },
    'form.business_id'(){
      this.getLocations()
    }
  },
  layout: Layout,

  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
      let multiselectClearButtons = document.getElementsByClassName('multiselect-clear')
      for(let i = 0 ; i < multiselectClearButtons.length; i++){
        multiselectClearButtons[i].click()
      }
    },
    getLocations(){
      let self = this
      self.selectedLocations = []
      axios.get('/ajax/list/locations',{
        params: {
          business_id: this.form.business_id,
        }
      }).then(function (result){
        self.selectedLocations = result.data.locations;
      });
    },
    getStatusColor(statusId){
      let statusColor = 'bg-indigo-500'
      if(statusId === 1)
        statusColor = 'bg-yellow-500'

      if(statusId === 3)
        statusColor = 'bg-orange-500'

      if(statusId === 4)
        statusColor = 'bg-indigo-900'

      if(statusId === 5)
        statusColor = 'bg-green-500'

      if(statusId === 6)
        statusColor = 'bg-red-500'

      return statusColor
    }
  }
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
